// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customer-code[data-v-e299890e]  .el-form-item__content {\n  width: 8.5em;\n}", ""]);
// Exports
module.exports = exports;
